import { Injectable } from '@angular/core';
import { AlgoritmoVentaTrosten } from '../algoritmo-venta-trosten.service';

@Injectable()
export class DistanceCalculatorService {

    constructor(private algoritmoVentaTrosten: AlgoritmoVentaTrosten) {}

    /**
     * Calculate kilometers from a Google Maps route response
     * Delegates to AlgoritmoVentaTrosten for consistency
     */
    public calculateKilometersFromRoute(route: any): number {
        return this.algoritmoVentaTrosten.calcularKilometrosRuta(route);
    }

    /**
     * Calculate kilometers with buffer distance
     * Delegates to AlgoritmoVentaTrosten for consistency
     */
    public calculateKilometersWithBuffer(kilometers: number): number {
        return this.algoritmoVentaTrosten.calcularKilometrosDeDistancia(kilometers);
    }

    /**
     * Calculate duration from a Google Maps route response
     * Delegates to AlgoritmoVentaTrosten for consistency
     */
    public calculateDurationFromRoute(route: any): number {
        return this.algoritmoVentaTrosten.calcularDuracionRuta(route);
    }

    /**
     * Calculate round-trip distance based on trip type
     * Returns the distance for return trip or 0 if one-way
     */
    public calculateReturnTripDistance(tripType: string, outboundDistance: number): number {
        if (tripType === 'Viaje Redondo') {
            return outboundDistance;
        }
        return 0;
    }

    /**
     * Calculate total kilometers for quotation
     * Includes all segments: origin point, main route, return trip
     */
    public calculateTotalQuotationKilometers(params: {
        googleKilometers: number;
        originPointDistance: number;
        returnTripDistance: number;
        returnToOriginDistance: number;
    }): number {
        const total = (params.googleKilometers / 1) + 
                     (params.returnToOriginDistance / 1) + 
                     (params.returnTripDistance / 1) + 
                     (params.originPointDistance / 1);
        return total;
    }

    /**
     * Calculate operator meal costs based on service hours
     * Rules:
     * - Hours <= 6: No meal costs
     * - Hours > 6: Base cost + additional costs per 8-hour period
     */
    public calculateOperatorMealCost(hours: number): number {
        if (hours <= 6) {
            return 0;
        }
        const hoursComidas = hours - 7;
        return 60 + (Math.floor(hoursComidas / 8) * 60);
    }

    /**
     * Calculate operator lodging costs based on service hours
     * Rules:
     * - Hours <= 35: No lodging costs
     * - Hours > 35: Base cost + additional costs per 24-hour period
     */
    public calculateOperatorLodgingCost(hours: number): number {
        if (hours <= 35) {
            return 0;
        }
        const hoursHospedaje = hours - 36;
        return 350 + (Math.floor(hoursHospedaje / 24) * 350);
    }

    /**
     * Calculate total hours between service start and end
     * Returns hours as ceiling value
     */
    public calculateServiceHours(startTime: number, endTime: number): number {
        return Math.ceil((endTime - startTime) / 3600000);
    }

    /**
     * Calculate distance from origin point with minimum threshold
     * If distance > 10km, subtract the free 10km threshold
     */
    public calculateOriginPointDistanceWithThreshold(distance: number, threshold: number = 10): number {
        if (distance > threshold) {
            return distance - threshold;
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/business-logic/distance-calculator.service.ts